import React, { Component } from 'react';

import { Seccion, SeccionDir } from '../../funciones/InscripcionFunction';
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

class SelectTable extends Component {
    state = {
        materia: this.props.id[1].materia,
        seccion: this.props.id[1].seccion,
        tipo: this.props.id[1].tipoM.label,
        semestre: this.props.id[4].label,
        uc: this.props.id[2],
        bs: this.props.id[3],
    }

    /* constructor (props) {
        super (props);
        if (this.props.type === "Est") {
            SeccionDir (this.props.idEst, this.props.id, (resp) => {
                this.setState(resp)
            })
        }else{
            Seccion (this.props.id, (resp) => {
                this.setState(resp)
            })
        }
    } */

    componentWillReceiveProps = (props) => {
        this.setState({
            materia: props.id[1].materia,
            seccion: props.id[1].seccion,
            tipo: props.id[1].tipoM.label,
            semestre: props.id[4].label,
            uc: props.id[2],
            bs: props.id[3],
        })
    }

    render() {
        let { materia, seccion, tipo, uc, semestre, bs } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <tr>
                <td style={styles}>
                    {materia}
                    <div className='text-primary'>{this.props.id[5]}</div>
                </td>
                <td style={styles} align="center">{seccion}</td>
                <td style={styles} align="center">{tipo}</td>
                <td style={{padding: 5, fontSize: 10}} align="center">{semestre}</td>
                <td style={styles} align="center">{uc}</td>
                <td style={styles} align="right">
                    {formatNumber(bs)} Bs.
                    {/* <div className = "text-danger">{formatReconver(bs)} Bs.</div> */}
                </td>
            </tr>
        );
    }
}
 
export default SelectTable;


// WEBPACK FOOTER //
// ./src/views/Inscripcion/SelectTable.jsx